import React from 'react'

import clsx from 'clsx'

import { BuyerIntentLeadClick, normalizeBuyerIntentId, warnMissingBuyerIntentIds } from 'components/BuyerIntent'
import ClickoutWrapper from 'components/ClickoutWrapper'
import CtaButton from 'components/CtaButton'
import Grid from 'components/Grid'
import Icon from 'components/Icon'
import Listing from 'components/Listing'
import { useEventContext } from 'context/EventContext'

import PricingDisplay from '../../../../components/PricingDisplay'

import classes from './Pricing.module.scss'

/** @type {import("./types").default} */
const Pricing = ({ className, listing, hasDemoForm, onClickPricing, position, ...props }) => {
  const { addEvent } = useEventContext({
    engagementComponent: 'best-product_card-item',
  })
  const buyerIntentProductId = normalizeBuyerIntentId(listing.global_product_id)

  if (hasDemoForm && !listing.is_premium && !buyerIntentProductId) {
    warnMissingBuyerIntentIds('best-product/pricing:get-price', {
      productId: listing.global_product_id,
    })
  }

  return (
    <Grid className={clsx('Pricing', classes.root, className)} {...props}>
      <div className={classes.container}>
        <PricingDisplay pricing={listing.pricing} />
        {hasDemoForm && !listing.is_premium ? (
          !buyerIntentProductId ? (
            <CtaButton
              data-testid="listing-item_main_cta"
              className={classes.button}
              onClick={onClickPricing}
              variant="contained"
              {...addEvent({
                engagementDetails: 'button_get_price',
                engagementDestination: 'go-to_ppl-price-form',
                name: 'engagement_product_click',
              })}
            >
              get price
            </CtaButton>
          ) : (
            <BuyerIntentLeadClick productId={buyerIntentProductId} sourceLocation="best-product/pricing:get-price">
              <CtaButton
                data-testid="listing-item_main_cta"
                className={classes.button}
                onClick={onClickPricing}
                variant="contained"
                {...addEvent({
                  engagementDetails: 'button_get_price',
                  engagementDestination: 'go-to_ppl-price-form',
                  name: 'engagement_product_click',
                })}
              >
                get price
              </CtaButton>
            </BuyerIntentLeadClick>
          )
        ) : (
          <ClickoutWrapper
            url={listing.cta_urls.cta}
            isClickout={listing.is_premium}
            listingPosition={position}
            buyerIntentProductId={buyerIntentProductId}
            buyerIntentSourceLocation="best-product/pricing:visit-website"
            buyerIntentTrackAdClick={listing.is_premium}
            {...addEvent(
              listing.is_premium
                ? {
                    productClickPosition: position,
                    engagementDetails: 'button_visit-website',
                    engagementDestination: 'go-to_vendor-website',
                    name: 'engagement_product_clickout',
                  }
                : {
                    productClickPosition: position,
                    engagementDetails: 'button_learn-more',
                    engagementDestination: 'go-to_product_details',
                    name: 'engagement_product_click',
                  }
            )}
          >
            <CtaButton
              data-testid="listing-item_main_cta"
              component="span"
              className={classes.button}
              variant="contained"
            >
              {listing.is_premium ? 'visit website ' : 'learn more'}
              {listing.is_premium && <Icon icon={['far', 'external-link']} size="14" />}
            </CtaButton>
          </ClickoutWrapper>
        )}
        <Listing.Buttons.Compare
          variant="outlined"
          listing={listing}
          className={classes.compareBtn}
          useBasket
          engagementComponent="best-product_card-item"
        />
      </div>
    </Grid>
  )
}

export default Pricing
